import React from "react";
import LandingLayout from "../../components/LandingLayout";
import { SubscriptionWrap } from "./styles";
import { Typography } from "antd";
import { FlexibleDiv } from "../../components/Box/styles";
import TakeLessonsWithYou from "../../components/TakeLessonsWithYou";
import { SubscriptionPlans } from "../../utils/dataHelpers/subscriptionPlans";
import Bubbles from "../../assets/pngs/bubbleBackground.png";

const Subscription = () => {
  const { Title, Text } = Typography;

  return (
    <LandingLayout>
      <SubscriptionWrap>
        <FlexibleDiv>
          <FlexibleDiv className="cardswrap">
            <Title level={3}>Exam Padi Subscription plans</Title>
            <FlexibleDiv
              width="900px"
              height="max-content"
              justifyContent="space-evenly"
            >
              {SubscriptionPlans.map((item, index) => (
                <FlexibleDiv
                  className="card"
                  key={index}
                  style={{ backgroundColor: item.color }}
                >
                  <Title level={5}>{item.title}</Title>
                  <FlexibleDiv flexDir="column" margin="10px 0">
                    <Title level={4}>{item.monthly}</Title>
                    <Title level={4}>{item.quaterly}</Title>
                    <Title level={4}>{item.yearly}</Title>
                  </FlexibleDiv>
                  <Text className="bodyText">{item.content}</Text>
                </FlexibleDiv>
              ))}
            </FlexibleDiv>
          </FlexibleDiv>
          <Title level={2}>
            Download the Exampadi App to buy a subscription plan and gain access
            to a library of content
          </Title>
          <FlexibleDiv>
            <TakeLessonsWithYou />
          </FlexibleDiv>
        </FlexibleDiv>
        <img src={Bubbles} alt="" className="backgroundBubbles" />
      </SubscriptionWrap>
    </LandingLayout>
  );
};

export default Subscription;
